// import React, { useState } from "react";
// import { Box, Button, Stack, TextField } from "@mui/material";

// import { useAppSelector } from "../../store/hooks";
// import CommentAvatar from "./CommentAvatar";
// import type { Comment } from "./VTBCommentTypes";

// interface CommentFormProps {
//   onSubmit: (comment: Comment) => void;
// }

// const CommentForm: React.FC<CommentFormProps> = ({ onSubmit }) => {
//   const [text, setText] = useState("");

//   const customerData = useAppSelector(
//     (state) => state.customer.personalDetails,
//   );

//   const usermasterId = sessionStorage.getItem("user_id");

//   const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();

//     const trimmedText = text.trim();

//     if (!trimmedText) return;

//     onSubmit({
//       user_id: Number(usermasterId) || 0,
//       first_name: customerData?.firstname ?? "GuestUser",
//       vid_comment: trimmedText,
//     });

//     setText("");
//   };

//   return (
//     <Box component="form" onSubmit={handleSubmit} mt={3}>
//       <Stack direction="row" spacing={2}>
//         <CommentAvatar
//           first_name={customerData?.firstname}
//           user_id={Number(usermasterId) || 0}
//         />

//         <TextField
//           fullWidth
//           value={text}
//           onChange={(e) => setText(e.target.value)}
//           label="Add a comment"
//           multiline
//           rows={2}
//         />
//       </Stack>

//       <Box mt={2} textAlign="right">
//         <Button type="submit" variant="contained" disabled={!text.trim()}>
//           Comment
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default CommentForm;

import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Box, Button, Stack, TextField } from "@mui/material";

import { useAppSelector } from "../../store/hooks";
import CommentAvatar from "./CommentAvatar";
import type { Comment } from "./VTBCommentTypes";

interface CommentFormProps {
  onSubmit: (comment: Comment) => void;
}

export interface CommentFormRef {
  focus: () => void;
}

const CommentForm = forwardRef<CommentFormRef, CommentFormProps>(
  ({ onSubmit }, ref) => {
    const [text, setText] = useState("");

    const inputRef = useRef<HTMLInputElement | null>(null);

    const customerData = useAppSelector(
      (state) => state.customer.personalDetails,
    );

    const usermasterId = sessionStorage.getItem("user_id");

    useImperativeHandle(ref, () => ({
      focus: () => {
        inputRef.current?.focus();
      },
    }));

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      const trimmedText = text.trim();

      if (!trimmedText) return;

      onSubmit({
        user_id: Number(usermasterId) || 0,
        first_name: customerData?.firstname ?? "GuestUser",
        vid_comment: trimmedText,
      });

      setText("");
    };

    return (
      <Box component="form" onSubmit={handleSubmit} mt={3}>
        <Stack direction="row" spacing={2}>
          <CommentAvatar
            first_name={customerData?.firstname}
            user_id={Number(usermasterId) || 0}
          />

          <TextField
            fullWidth
            value={text}
            onChange={(e) => setText(e.target.value)}
            label="Add a comment"
            multiline
            rows={2}
            inputRef={inputRef}
          />
        </Stack>

        <Box mt={2} textAlign="right">
          <Button type="submit" variant="contained" disabled={!text.trim()}>
            Comment
          </Button>
        </Box>
      </Box>
    );
  },
);

CommentForm.displayName = "CommentForm";

export default CommentForm;
